var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1624_22176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 9.99997L9.58686 20.5862C9.22091 20.9632 9.018 21.469 9.02195 21.9944C9.02591 22.5197 9.23642 23.0224 9.60799 23.3938C9.97957 23.7652 10.4824 23.9755 11.0077 23.9792C11.5331 23.983 12.0388 23.7798 12.4156 23.4137L24.8294 10.8287C25.5796 10.0785 26.0011 9.06096 26.0011 7.99997C26.0011 6.93898 25.5796 5.92145 24.8294 5.17122C24.0791 4.42099 23.0616 3.99951 22.0006 3.99951C20.9396 3.99951 19.9221 4.42099 19.1719 5.17122L6.75811 17.7575C5.64802 18.8858 5.02876 20.407 5.03521 21.9898C5.04165 23.5727 5.67328 25.0888 6.79252 26.2081C7.91175 27.3273 9.4279 27.9589 11.0107 27.9654C12.5935 27.9718 14.1148 27.3525 15.2431 26.2425L25.5006 16",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1624_22176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.b1516f58983bd0da839df15329d131e6.svg";
export { ForwardRef as ReactComponent };